export enum ScrollDirection {
	Vertical = 'scrollTop',
	Horizontal = 'scrollLeft',
}
